import React from 'react';
import { Sidebar, type SidebarProps } from 'primereact/sidebar';
import { CloseButton, CloseButtonSize } from '../LiliCloseButton/CloseButton';
// ponytail: CSS imported at app-level index.css — bare imports here get tree-shaken by sideEffects:["*.css"]
import { twMerge } from 'tailwind-merge';
import { FontWeight, getFontClass } from '../../tokens';
export enum LiliDrawerPosition {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}

// See https://primereact.org/sidebar/ and add any additional props that you need
export interface LiliDrawerProps extends SidebarProps {
  visible: boolean;
  onHide: () => void;
  children: React.ReactNode;
  position?: LiliDrawerPosition;
  header?: string;
  width?: string;
  noHeader?: boolean;
  showOverlay?: boolean;
  wrapperClassName?: string;
}

export const LiliDrawer = (props: LiliDrawerProps) => {
  const {
    visible,
    onHide,
    children,
    position = LiliDrawerPosition.RIGHT,
    header,
    width,
    noHeader,
    showOverlay = true,
    wrapperClassName,
    ...otherProps
  } = props;

  const renderSidebarContent = () => (
    <div className={twMerge('flex flex-col h-full', wrapperClassName)}>
      {!noHeader && (
        <div className='h-[58px] p-[16px] flex flex-row justify-between border-b-[1px] border-b-outline-primary-bw-03'>
          <CloseButton id='close-drawer' onClick={onHide} size={CloseButtonSize.Large} />
          {header && (
            <div
              className={`flex flex-row w-full ${getFontClass(
                FontWeight.MEDIUM
              )} text-lg text-text-main-primary justify-center`}>
              {header}
            </div>
          )}
        </div>
      )}
      <div className='h-full'>{children}</div>
    </div>
  );

  return (
    <Sidebar
      visible={visible}
      onHide={onHide}
      position={position}
      content={renderSidebarContent}
      style={{ width: width || '500px' }}
      showCloseIcon={false}
      modal={showOverlay}
      {...otherProps}>
      {children}
    </Sidebar>
  );
};
